import type { IThirdPartySnippetsItem } from '@booking-portal/types';
import type { IResponse } from '@booking-portal/types/api';
import { httpClient } from '@booking-portal/utils/fetch-utils';

export function getTrackingSnippet(
  locationId?: number | null
): Promise<IResponse<IThirdPartySnippetsItem[]>> {
  const params = locationId ? { locationIds: locationId } : {};
  return httpClient
    .get<IResponse<IThirdPartySnippetsItem[]>>('/snippet', { params })
    .then((response) => response.data);
}
